import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const COLORS = ['#ffd6b1', '#b1dbff', '#00C49F', '#FFBB28', '#FF8042', '#b7edb8', '#ffff82', '#fc8fc4'];

const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, outerRadius, fill, payload, percent } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 5) * cos;
    const sy = cy + (outerRadius + 5) * sin;
    const mx = cx + (outerRadius + 20) * cos;
    const my = cy + (outerRadius + 20) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 3;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    // 선 길이 조정
    const line = () => {
        return <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />;
    };

    // n명(n%) 표기 위치 조정
    const labelAndPercent = (name) => {
        return (
            <text x={ex + (cos >= 0 ? 1 : -1) * 3} y={ey + 2} textAnchor={textAnchor}>
                <tspan x={ex + (cos >= 0 ? 1 : -1) * 3} dy="0" fill="#333" style={{ fontSize: '9px', fontWeight: 'bold' }}>
                    {payload.name}
                </tspan>
                <tspan x={ex + (cos >= 0 ? 1 : -1) * 3} dy="10" fill="#999" style={{ fontSize: '9px' }}>
                    {`(${(percent * 100).toFixed(2)}%)`}
                </tspan>
            </text>
        );
    };

    return (
        <g>
            {line(payload.name)}
            {labelAndPercent(payload.name)}
        </g>
    );
};

function PieChartComponents({ datas }) {
    // 300 300
    return (
        <ResponsiveContainer width={350} height={350}>
            <PieChart>
                <Pie
                    data={datas}
                    cx="50%" // "30%"
                    cy="30%" // "28%"
                    label={renderActiveShape} // label={renderCustomizedLabel}, label
                    labelLine={true} // labelLine={false}
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="value"
                >
                    {datas?.map((entry, index) => {
                        return <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />;
                    })}
                </Pie>
            </PieChart>
        </ResponsiveContainer>
    );
}

export default PieChartComponents;
